import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  dismiss() {
    let wrapper = this.element.parentElement
    this.element.remove()

    while (wrapper && wrapper.children.length === 0) {
      const parent = wrapper.parentElement
      wrapper.remove()
      wrapper = parent
    }
  }
}
